import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import analytics from '@nerdwallet/analytics';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { CheckboxInline as Checkbox } from '@nerdwallet/react-checkbox';
import Button from '@nerdwallet/react-button';
import Check from '@nerdwallet/react-icon/gizmo/Check';
import Plus from '@nerdwallet/react-icon/gizmo/Plus'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import cloneDeep from 'lodash/cloneDeep'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import values from 'lodash/values';
import * as actions from '../redux/actions';
import './compare-card-checkbox.less';
var InteractionLocation = 'compare-card-checkbox';
export var CHECKBOX_STYLE = {
  CHECKBOX: 'checkbox',
  BUTTON: 'button'
};
export var CompareCardCheckbox = /*#__PURE__*/function (_React$Component) {
  _inherits(CompareCardCheckbox, _React$Component);

  var _super = _createSuper(CompareCardCheckbox);

  function CompareCardCheckbox() {
    var _this;

    _classCallCheck(this, CompareCardCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleCompareCardChange", function (e, addCardOverride) {
      if (e && e.target.checked || addCardOverride) {
        // Set a flag denoting we need to fetch more compare data
        var cardToAdd = cloneDeep(_this.props.card);
        cardToAdd.fetchCompareData = true;

        _this.props.saveToCompare({
          cards: [cardToAdd],
          productLocation: InteractionLocation
        });
      } else {
        _this.props.removeFromCompare(_this.props.card.id, InteractionLocation);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireAnalyticsEvent", function (isInCompare, impressionId) {
      var _this$props$analytics;

      if ((_this$props$analytics = _this.props.analytics) !== null && _this$props$analytics !== void 0 && _this$props$analytics.enabled || _this.props.enableAnalytics) {
        var elementInteractedPayload = {
          entity_name: "product_card_compare",
          action: isInCompare ? 'unselect' : 'select',
          interaction_type: 'press'
        };

        if (impressionId) {
          elementInteractedPayload.impression_id = impressionId;
        }

        analytics.track('element_interacted', elementInteractedPayload);
      }
    });

    return _this;
  }

  _createClass(CompareCardCheckbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIDsToCompare = get(this.props, 'compareCards.cardIDsToCompare') || [];
      var isInCompare = cardIDsToCompare.indexOf(this.props.card.id) > -1;
      var onChange = this.props.handleCompare || this.handleCompareCardChange;
      var classes = classnames('compare-checkbox', {
        'compare-checkbox--button': this.props.elementStyle === CHECKBOX_STYLE.BUTTON
      });

      var checkBoxClickHandler = function checkBoxClickHandler(e, impressionId) {
        _this2.fireAnalyticsEvent(isInCompare, impressionId);

        onChange(e);
      };

      var component = /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          label: _this2.props.label,
          checked: isInCompare,
          onChange: function onChange(e) {
            return checkBoxClickHandler(e, value === null || value === void 0 ? void 0 : value.impressionId);
          }
        });
      }); // if the addText or removeText is undefined or an empty string
      // then use the default value else use the value passed in by the consumer

      var addText = this.props.addText || "Add to compare";
      var removeText = this.props.removeText || "Added to compare";

      if (this.props.elementStyle === CHECKBOX_STYLE.BUTTON) {
        var text = isInCompare ? removeText : addText;

        var buttonClickHandler = function buttonClickHandler(impressionId) {
          _this2.fireAnalyticsEvent(isInCompare, impressionId);

          onChange(null, !isInCompare);
        };

        component = /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (value) {
          return /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick() {
              return buttonClickHandler(value === null || value === void 0 ? void 0 : value.impressionId);
            },
            className: "compare-button"
          }, isInCompare ? /*#__PURE__*/React.createElement(Check, {
            className: "icon",
            size: 16
          }) : /*#__PURE__*/React.createElement(Plus, {
            className: "icon",
            size: 16
          }), /*#__PURE__*/React.createElement("span", null, text));
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, component);
    }
  }]);

  return CompareCardCheckbox;
}(React.Component);

_defineProperty(CompareCardCheckbox, "propTypes", {
  label: PropTypes.string,
  card: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  // ** Deprecated use analytics prop instead **
  enableAnalytics: PropTypes.bool,
  analytics: PropTypes.shape({
    enabled: PropTypes.bool
  }),
  handleCompare: PropTypes.func,
  saveToCompare: PropTypes.func.isRequired,
  removeFromCompare: PropTypes.func.isRequired,
  elementStyle: PropTypes.oneOf(values(CHECKBOX_STYLE)),
  addText: PropTypes.string,
  removeText: PropTypes.string
});

_defineProperty(CompareCardCheckbox, "defaultProps", {
  label: 'Compare this card',
  elementStyle: CHECKBOX_STYLE.CHECKBOX,
  enableAnalytics: false,
  analytics: {
    enabled: false
  },
  addText: 'Add to compare',
  removeText: 'Added to compare'
});

var mapStateToProps = function mapStateToProps(_ref) {
  var compareCards = _ref.compareCards;
  return {
    compareCards: compareCards
  };
};

var mapDispatchToProps = {
  saveToCompare: actions.saveToCompare,
  removeFromCompare: actions.removeFromCompare
};
export default connect(mapStateToProps, mapDispatchToProps)(CompareCardCheckbox);
//# sourceMappingURL=compare-card-checkbox.js.map